export default __webpack_public_path__ + "static/media/RPG_3.4f403f44.png";